const flavorMap = {
	Naranja: 'Naranja',
	Vainilla: 'Vainilla',
	Chocolate: 'Chocolate',
	Fresa: 'Fresa',
	Helado: 'Helado',
	'Cookies and Cream': 'Cookies and Cream',
	Sandía: 'Sandía',
	'Manzana Verde': 'Manzana Verde',
	'Sin Sabor': 'Sin Sabor',
	Ponche: 'Ponche',
	'Frutos Rojos': 'Frutos Rojos',
	'Frutos Amarillos': 'Frutos Amarillos',
	'Frutos Azules': 'Frutos Azules',
	'Frutos Morados': 'Frutos Morados',
	Coco: 'Coco',
	Mango: 'Mango',
	Plátano: 'Plátano',
	'Piña Colada': 'Piña Colada',
	Café: 'Café',
	Caramelo: 'Caramelo',
	Menta: 'Menta',
	'Té Verde': 'Té Verde',
	Limón: 'Limón',
	Mora: 'Mora',
	Maracuyá: 'Maracuyá',
	Uva: 'Uva',
	Durazno: 'Durazno',
	Chicle: 'Chicle',
	Almendra: 'Almendra',
	Avellana: 'Avellana',
	Guayaba: 'Guayaba',
	Feijoa: 'Feijoa',
	Lulo: 'Lulo',
	Tamarindo: 'Tamarindo',
	Borojo: 'Borojó',
	Guanábana: 'Guanábana',
	Mangostino: 'Mangostino',
	Arazá: 'Arazá',
	Chontaduro: 'Chontaduro',
	Corozo: 'Corozo',
	Arándano: 'Arándano',
	Frambuesa: 'Frambuesa',
	Moras_Azules: 'Moras Azules',
	'Berry Mix': 'Berry Mix',
	Cranberry: 'Cranberry',
	'Blueberry Cheesecake': 'Blueberry Cheesecake',
	Arequipe: 'Arequipe',
	'Panela y Limón': 'Panela y Limón',
	'Vainilla Caramelo': 'Vainilla Caramelo',
	'Chocolate Blanco': 'Chocolate Blanco',
	Brownie: 'Brownie',
	Banano: 'Banano',
	'Vainilla Banano': 'Vainilla Banano',
	"Gulupa Ice": "Gulupa Ice",
	"Red Fusion": "Red Fusion",
	"Watermelon Candy": "Watermelon Candy",
	"Té chai": "Té chai",
	"Helado de Fresa": 'Helado de Fresa',
	"Canela": 'Canela',
	'Birthday Cake': 'Birthday Cake',
	'Funfetti': 'Funfetti',
	'Cake Batter': 'Cake Batter',
	'Vanilla Milkshake': 'Vanilla Milkshake',
	'Chocolate Milkshake': 'Chocolate Milkshake',
	'Strawberry Milkshake': 'Strawberry Milkshake',
	'Oreo': 'Oreo',
	'Double Chocolate': 'Double Chocolate',
	'Mint Chocolate': 'Mint Chocolate',
	'Chocolate Peanut Butter': 'Chocolate Peanut Butter',
	'White Chocolate': 'White Chocolate',
	'Mocha': 'Mocha',
	'Cappuccino': 'Cappuccino',
	'Espresso': 'Espresso',
	'Latte': 'Latte',
	'French Vanilla': 'French Vanilla',
	'Vanilla Ice Cream': 'Vanilla Ice Cream',
	'Neapolitan': 'Neapolitan',
	'Rocky Road': 'Rocky Road',
	'Mint Chip': 'Mint Chip',
	'Strawberry Cheesecake': 'Strawberry Cheesecake',
	'Chocolate Cheesecake': 'Chocolate Cheesecake',
	'Vanilla Cheesecake': 'Vanilla Cheesecake',
	'New York Cheesecake': 'New York Cheesecake',
	'Tiramisú': 'Tiramisú',
	'Red Velvet': 'Red Velvet',
	'Cinnamon Roll': 'Cinnamon Roll',
	'Apple Pie': 'Apple Pie',
	'Pumpkin Pie': 'Pumpkin Pie',
	'Banana Cream': 'Banana Cream',
	'Coconut Cream': 'Coconut Cream',
	'Lemon Pie': 'Lemon Pie',
	'Key Lime Pie': 'Key Lime Pie',
	'Dragon Fruit': 'Dragon Fruit',
	'Lychee': 'Lychee',
	'Passion Fruit': 'Passion Fruit',
	'Acai': 'Acai',
	'Pomegranate': 'Pomegranate',
	'Blood Orange': 'Blood Orange',
	'Pink Grapefruit': 'Pink Grapefruit',
	'Kiwi': 'Kiwi',
	'Papaya': 'Papaya',
	'Starfruit': 'Starfruit',
	'Jackfruit': 'Jackfruit',
	'Rambutan': 'Rambutan',
	'Mangosteen': 'Mangosteen',
	'Tropical Punch': 'Tropical Punch',
	'Bahama Mama': 'Bahama Mama',
	'Hurricane': 'Hurricane',
	'Mai Tai': 'Mai Tai',
	'Blue Hawaii': 'Blue Hawaii',
	'Pineapple Mango': 'Pineapple Mango',
	'Coconut Pineapple': 'Coconut Pineapple',
	'Banana Coconut': 'Banana Coconut',
	'Mango Passion': 'Mango Passion',
	'Cotton Candy': 'Cotton Candy',
	'Bubble Gum': 'Bubble Gum',
	'Jolly Rancher': 'Jolly Rancher',
	'Skittles': 'Skittles',
	'Starburst': 'Starburst',
	'Sour Apple': 'Sour Apple',
	'Sour Cherry': 'Sour Cherry',
	'Blue Raspberry': 'Blue Raspberry',
	'Grape Soda': 'Grape Soda',
	'Orange Cream': 'Orange Cream',
	'Root Beer Float': 'Root Beer Float',
	'Cherry Cola': 'Cherry Cola',
	'Lemon Lime': 'Lemon Lime',
	'Fruit Punch': 'Fruit Punch',
	'Salted Caramel': 'Salted Caramel',
	'Caramel Macchiato': 'Caramel Macchiato',
	'Dulce de Leche': 'Dulce de Leche',
	'Maple Syrup': 'Maple Syrup',
	'Honey': 'Honey',
	'Peanut Butter': 'Peanut Butter',
	'Almond Butter': 'Almond Butter',
	'Cashew': 'Cashew',
	'Pistachio': 'Pistachio',
	'Macadamia': 'Macadamia',
	'Pecan': 'Pecan',
	'Walnut': 'Walnut',
	'Chai Latte': 'Chai Latte',
	'Pumpkin Spice': 'Pumpkin Spice',
	'Gingerbread': 'Gingerbread',
	'Eggnog': 'Eggnog',
	'Cardamom': 'Cardamom',
	'Clove': 'Clove',
	'Nutmeg': 'Nutmeg',
	'Allspice': 'Allspice',
	'Mora Castilla': 'Mora Castilla',
	'Uchuva': 'Uchuva',
	'Pitahaya': 'Pitahaya',
	'Zapote': 'Zapote',
	'Mamey': 'Mamey',
	'Curuba': 'Curuba',
	'Granadilla': 'Granadilla',
	'Tomate de Árbol': 'Tomate de Árbol',
	'Badea': 'Badea',
	'Níspero': 'Níspero',
	'Chirimoya': 'Chirimoya',
	'Anón': 'Anón',
	'Pomarrosa': 'Pomarrosa',
	'Carambolo': 'Carambolo',
	'Mojito': 'Mojito',
	'Caipirinha': 'Caipirinha',
	'Margarita': 'Margarita',
	'Sex on the Beach': 'Sex on the Beach',
	'Cosmopolitan': 'Cosmopolitan',
	'Blue Lagoon': 'Blue Lagoon',
	'Tequila Sunrise': 'Tequila Sunrise',
	'Long Island': 'Long Island',
	'Sangria': 'Sangria',
	'Fruity Pebbles': 'Fruity Pebbles',
	'Cocoa Puffs': 'Cocoa Puffs',
	'Lucky Charms': 'Lucky Charms',
	'Froot Loops': 'Froot Loops',
	'Cinnamon Toast Crunch': 'Cinnamon Toast Crunch',
	'Captain Crunch': 'Captain Crunch',
	'Honeycomb': 'Honeycomb',
	'Cornflakes': 'Cornflakes',
	'Lavender': 'Lavender',
	'Rose': 'Rose',
	'Hibiscus': 'Hibiscus',
	'Earl Grey': 'Earl Grey',
	'Matcha': 'Matcha',
	'Jasmine': 'Jasmine',
	'Elderflower': 'Elderflower',
	'Cucumber Mint': 'Cucumber Mint',
	'Basil': 'Basil',
	'Rosemary': 'Rosemary',
	'Thyme': 'Thyme',
	'Energy Drink': 'Energy Drink',
	'Monster': 'Monster',
	'Red Bull': 'Red Bull',
	'Rockstar': 'Rockstar',
	'NOS': 'NOS',
	'Bang': 'Bang',
	'Reign': 'Reign',
	'Christmas Cookie': 'Christmas Cookie',
	'Peppermint Bark': 'Peppermint Bark',
	'Hot Chocolate': 'Hot Chocolate',
	'Marshmallow': 'Marshmallow',
	'Graham Cracker': 'Graham Cracker',
	'S\'mores': 'S\'mores',
	'Mochi': 'Mochi',
	'Taro': 'Taro',
	'Ube': 'Ube',
	'Lemon Curd': 'Lemon Curd',
	'Elderberry': 'Elderberry',
	'Gooseberry': 'Gooseberry',
	'Blackcurrant': 'Blackcurrant',
	'Rhubarb': 'Rhubarb',
	'Chocolate Mint Chip': 'Chocolate Mint Chip',
	'Strawberry Banana': 'Strawberry Banana',
	'Apple Cinnamon': 'Apple Cinnamon',
	'Orange Vanilla': 'Orange Vanilla',
	'Lemon Vanilla': 'Lemon Vanilla',
	'Cherry Vanilla': 'Cherry Vanilla',
	'Peach Mango': 'Peach Mango',
	'Berry Banana': 'Berry Banana',
	'Tropical Mango': 'Tropical Mango',
	'Wild Berry': 'Wild Berry',
	'Mixed Berry': 'Mixed Berry',
	'Forest Berry': 'Forest Berry',
	'Summer Berry': 'Summer Berry',
	'Winter Berry': 'Winter Berry',
	'Icy Blue Razz': 'Icy Blue Razz',
	'Tigers Blood': 'Tigers Blood',
	'Bombsicle': 'Bombsicle',
	'Rocket Pop': 'Rocket Pop',
	'Miami Vice': 'Miami Vice',
	'Patty\'s Iced Tea': 'Patty\'s Iced Tea',
	'White Gummy Bear': 'White Gummy Bear',
	'Orange Ice Dream': 'Orange Ice Dream',
	'Mango Peach': 'Mango Peach',
	'Blackberry Lemonade': 'Blackberry Lemonade',
	'Berry Burst': 'Berry Burst',
	'Citrus Rain': 'Citrus Rain',
	'Tropic Wave': 'Tropic Wave',
	'Lucky Lemon': 'Lucky Lemon',
	'Sour Watermelon Candy': 'Sour Watermelon Candy',
	'Wild Grape': 'Wild Grape',
	'Lychee Bomb': 'Lychee Bomb',
	'Strawberry Candy': 'Strawberry Candy',
	'Orange Rush': 'Orange Rush',
	'Black Cherry Vanilla': 'Black Cherry Vanilla',
	'Exotic Kiwi': 'Exotic Kiwi',
	'White Frost': 'White Frost',
	'Gym N Juice': 'Gym N Juice',
	'Blood Raz': 'Blood Raz',
	'Killa OJ': 'Killa OJ',
	'Green Apple Jolly Rancher': 'Green Apple Jolly Rancher',
	'Sour Peach Rings': 'Sour Peach Rings',
	'Arctic White': 'Arctic White',
	'Osaka Cherry Blossom': 'Osaka Cherry Blossom',
	'Baba Yaga Blue Raz': 'Baba Yaga Blue Raz',
	'Coffee Ice Cream': 'Coffee Ice Cream',
	'Slow Churn Vanilla': 'Slow Churn Vanilla',
	'Cookies N Cream Ice Cream': 'Cookies N Cream Ice Cream',
	'Mint Chocolate Chip Ice Cream': 'Mint Chocolate Chip Ice Cream',
	'Strawberry Ice Cream': 'Strawberry Ice Cream',
	'Pistachio Ice Cream': 'Pistachio Ice Cream',
	'Butter Pecan Ice Cream': 'Butter Pecan Ice Cream',
	'Italian Ice Cream': 'Italian Ice Cream',
	'Rainbow Sherbet': 'Rainbow Sherbet',
	'Orange Creamsicle': 'Orange Creamsicle',
	'Banana Split': 'Banana Split',
	'Caramel Swirl': 'Caramel Swirl',
	'Fudge Brownie': 'Fudge Brownie',
	'Key Lime Sherbet': 'Key Lime Sherbet',
	'Coconut Ice Cream': 'Coconut Ice Cream',
	'Camu Camu': 'Camu Camu',
	'Copoazú': 'Copoazú',
	'Canangucha': 'Canangucha',
	'Cocona': 'Cocona',
	'Maraco': 'Maraco',
	'Piña Amazónica': 'Piña Amazónica',
	'Lulo Amazónico': 'Lulo Amazónico',
	'Anón Amazónico': 'Anón Amazónico',
	'Papayuela': 'Papayuela',
	'Melón Colombiano': 'Melón Colombiano',
	'Tamarillo': 'Tamarillo',
	'Chontaduro Dulce': 'Chontaduro Dulce',
	'Madroño': 'Madroño',
	'Pepino Dulce': 'Pepino Dulce',
	'Gulupa Morada': 'Gulupa Morada',
	'Pitaya Rosa': 'Pitaya Rosa',
	'Aguacate Hass': 'Aguacate Hass',
	'Café Colombiano': 'Café Colombiano',
	'Panela': 'Panela',
	'Aguapanela': 'Aguapanela',
	'Bocadillo Veleño': 'Bocadillo Veleño',
	'Cocada': 'Cocada',
	'Arroz con Leche': 'Arroz con Leche',
	'Natilla': 'Natilla',
	'Brevas con Arequipe': 'Brevas con Arequipe',
	'Roscón': 'Roscón',
	'Alfajor': 'Alfajor',
	'Mazamorra': 'Mazamorra',
	'Chicha': 'Chicha',
	'Avena': 'Avena',
	'Quinua': 'Quinua',
	'Chía': 'Chía',
	'Amaranto': 'Amaranto',
	'Blue Ice': 'Blue Ice',
	'Red Ice': 'Red Ice',
	'Purple Ice': 'Purple Ice',
	'Green Ice': 'Green Ice',
	'Yellow Ice': 'Yellow Ice',
	'Electric Lemon': 'Electric Lemon',
	'Neon Lime': 'Neon Lime',
	'Atomic Orange': 'Atomic Orange',
	'Lightning Berry': 'Lightning Berry',
	'Thunder Grape': 'Thunder Grape',
	'Voltage Cherry': 'Voltage Cherry',
	'Shock Wave': 'Shock Wave',
	'Power Surge': 'Power Surge',
	'Energy Blast': 'Energy Blast',
	'Turbo Punch': 'Turbo Punch',
	'Nitro Cola': 'Nitro Cola',
	'High Voltage': 'High Voltage',
	'Electric Storm': 'Electric Storm',
	'Laser Lime': 'Laser Lime',
	'Cyber Grape': 'Cyber Grape',
	'Matrix Green': 'Matrix Green',
	'Neon Blue': 'Neon Blue',
	'Electric Pink': 'Electric Pink',
	'Plasma Purple': 'Plasma Purple',
	'Ion Orange': 'Ion Orange',
	'Fusion Berry': 'Fusion Berry',
	'X-treme Citrus': 'X-treme Citrus',
	'Ultra Violet': 'Ultra Violet',
	'Mega Mix': 'Mega Mix',
	'Hyper Melon': 'Hyper Melon',
	'Super Sour': 'Super Sour',
	'Extreme Energy': 'Extreme Energy',
	'Maximum Power': 'Maximum Power',
	'Ultimate Rush': 'Ultimate Rush',
	'Infinity Punch': 'Infinity Punch',
	'Especial': 'Especial',
	'Frutos Tropicales' : 'Frutos Tropicales' 
} as const

export default flavorMap